import {
  sessionStorage,
  localStorage
} from '../../kodyl-js/client/web-storage';
import qs from 'qs';

// TODO: Save in cookie (to use with FB signup)

const STORAGE_KEY = '__/bn/utm';

export function getUtmParams() {
  try {
    const utm = localStorage.getItem(STORAGE_KEY);
    return qs.parse(utm) || {};
  } catch (err) {
    if (__DEV__) {
      console.error(err);
    }
    return {};
  }
}

export function saveUtmParams() {
  if (__CLIENT__) {
    const loc = global.location;
    const utmPattern = /utm_/;
    if (utmPattern.test(loc.href)) {
      const o = {
        ...qs.parse(loc.search.substr(1)),
        ...qs.parse(loc.hash.substr(1))
      };
      const utm = Object.keys(o).reduce((acc, key) => {
        if (utmPattern.test(key)) {
          acc[key.replace(utmPattern, '')] = o[key];
        }
        return acc;
      }, {});

      if (!sessionStorage.getItem(STORAGE_KEY)) {
        sessionStorage.setItem(STORAGE_KEY, qs.stringify(utm));
      }
      if (!localStorage.getItem(STORAGE_KEY)) {
        localStorage.setItem(STORAGE_KEY, qs.stringify(utm));
      }
    }
  }
}
